import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './fonts/css/all.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './styles/packages.scss';
import { ThemeProvider } from './utils/ThemeProvider';

import Analytics from './pages/Analytics';
import Orders from './pages/Orders';
import Items from './pages/Items';
import Settings from './pages/Settings';
import ItemDetails from './pages/ItemDetails';
import OfferDetails from './pages/OfferDetails';
import StoreInfo from './pages/StoreInfo';
import Login from './pages/Login';
import Offers from './pages/Offers';
import BusinessInfo from './pages/BusinessInfo';
import ItemsPending from './pages/ItemsPending';
import OffersPending from './pages/OffersPending';
import Categories from './pages/Categories';
import { Provider } from 'react-redux';
import store from './store';
import 'react-toastify/dist/ReactToastify.css';
import Employees from './pages/Employees';
import Signup from './pages/Signup';
import Profile from './pages/Profile';
import { SidebarProvider } from './utils/SidebarProvider';
import AppWrapper from './AppWrapper';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Support from './pages/Support';
import Charities from './pages/Charities';
import SignupFinish from './pages/signup-steps/SignupFinish';
import Verify from './pages/Verify';
import Pin from './pages/Pin';
import POSEnabled from './pages/POSEnabled';

import 'swiper/scss';
import 'swiper/scss/scrollbar';
import Bank from './pages/Bank';
import Pos from './pages/Pos';
import Home from './pages/Home';

import axios from 'axios';

import { initCachedUser, getRefreshedToken } from './slices/auth';
import { getPersonalDetails } from './slices/auth';
import ResetPass from './pages/ResetPass';
import ForgotPassword from './pages/ForgotPassword';
import SetPin from './pages/SetPin';

const hostname = window.location.hostname;

if (
  hostname == 'sell.livecart.ai' ||
  hostname == 'livecart.store' ||
  hostname == 'www.livecart.store'
) {
  // FIXME: When dev branch is changed, set .env variables
  axios.defaults.baseURL = 'https://api.livecart-production.com';
} else {
  axios.defaults.baseURL = 'https://api.dev-box.livecart-production.com';
}

store.dispatch(initCachedUser());
store.dispatch(getRefreshedToken()).then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <AppWrapper>
            <ThemeProvider>
              <SidebarProvider>
                {/* <App /> */}
                <Routes>
                  <Route path="login" element={<Login />} />
                  <Route path="pos-enabled" element={<POSEnabled />} />
                  <Route path="signup" element={<Signup />} />
                  <Route path="pin" element={<Pin />} />
                  
                  {/* set-pin is same as verify */}
                  <Route path="set-pin" element={<SetPin />} />

                  <Route path="forgot-password" element={<ForgotPassword />} />
                  <Route path="verify" element={<Verify />} />
                  <Route path="signup/finish" element={<SignupFinish />} />
                  <Route path="forgot-password/:hash/:email" element={<ResetPass />} />
                  <Route path="confirmation/:hash/:email/merchant" element={<Verify />} />
                  <Route path="confirmation/:hash/:email/employee" element={<ResetPass />} />
                  <Route path="" element={<Navigate to="/login" />} />
                  <Route path="/" element={<App />}>
                    {/* <Route path='/' element={<Navigate to='/login' />}> */}
                    {/* redirect on open to Analytics */}
                    <Route path="home" element={<Home />} />
                    <Route path="analytics" element={<Analytics />} />
                    <Route path="orders" element={<Orders />} />
                    <Route path="items" element={<Items />} />
                    <Route path="items/:item" element={<ItemDetails />} />
                    <Route path="pending-items" element={<ItemsPending />} />
                    <Route path="offers" element={<Offers />} />
                    <Route path="offers/:offer" element={<OfferDetails />} />
                    <Route path="pending-offers" element={<OffersPending />} />
                    <Route path="settings" element={<Settings />} />
                    {/* <Route
											path='categories'
											element={<Categories />}
										/> */}
                    <Route path="store-details" element={<StoreInfo />} />
                    <Route path="bank" element={<Bank />} />
                    <Route path="pos" element={<Pos />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="employees" element={<Employees />} />
                    <Route path="terms-of-service" element={<TermsOfService />} />
                    <Route path="privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="support" element={<Support />} />
                    <Route path="charities" element={<Charities />} />
                  </Route>
                  <Route path="*" element={<Navigate to="/" repalce />} />
                </Routes>
              </SidebarProvider>
            </ThemeProvider>
          </AppWrapper>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
  );
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an Analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
